import { InputFormTypeSelect } from "../../mod.ts";
import { InputFormTypeAllType } from "../../../types.ts";
import { DropdownItemType } from "@config/app/questionTemplates/types.ts";
import { countries } from "@services/translation/countries.ts";
import { ContentType } from "@components/Input/mod.ts";
import { Helper } from "@services/Helper.ts";

export const SelectCountry = (
  {
    value,
    data: {
      id,
      label,
      required,
      disabled,
      reference,
      placeholder,
    },
    onError,
    onSuccess,
    lastCheckedAt = 0,
  }: InputFormTypeAllType<{
    data: DropdownItemType;
  }>,
) => {
  const countriesSorted = Helper.sortCountries(countries);

  return (
    <InputFormTypeSelect
      onSuccess={onSuccess}
      onError={onError}
      id={id}
      label={label}
      name={reference}
      placeholder={placeholder}
      fields={countriesSorted}
      value={value}
      isRequired={required}
      isDisabled={disabled}
      lastCheckedAt={lastCheckedAt}
    />
  );
};
